import { useContext } from 'react';
import { Grid2 as Grid, Avatar, Box, Card, CardContent, CardHeader, ListItem, ListItemAvatar, ListItemText, Typography, Stack, Chip, useMediaQuery } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import { FilersDataContext } from '../../../Filers';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';

const TagTypeWinner = 2;

const ElectionTimelines = (): JSX.Element => {

    const theme = useTheme();
    const filerDataContext = useContext(FilersDataContext);
    const currentFiler = filerDataContext.currentFilerPayload?.filer;
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
      });

    return (
        <Grid size={{ xs: 12, md: 4.5 }} marginTop={2} data-aos={'fade-up'}>
          <Card 
            sx={{
                "&:hover": {
                    boxShadow: "0 0 10px #ccc",
                },
                borderTop: `2px solid`,
                borderTopColor: blue[700],
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                width: '100%',
                height: '100%',
              }}
            data-aos={'fade-up'}
            >
            <CardHeader
                avatar={
                <Avatar sx={{ bgcolor: blue[500] }} className="small-avatar">
                    <CalendarMonthIcon fontSize="small" />
                </Avatar>}
                padding={1}
                title={
                    <Typography
                    variant="h6">
                    Election Timelines
                    </Typography>
                }                                                      
            />                                                   
            <CardContent className="card-content">
                <Grid container spacing={1}>
                    <Timeline 
                     sx={{
                        [`& .${timelineOppositeContentClasses.root}`]: {
                          flex: 0.1,
                        },
                      }}
                    >
                    {
                        currentFiler?.tags.map((tag) => (
                            <TimelineItem key={tag.id}>
                            <TimelineOppositeContent
                                sx={{padding: "6px 10px"}}
                            >
                                <Typography variant="subtitle2">
                                    {tag.year}
                                </Typography>
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                            <TimelineDot color={
                                tag.tagTypeId === TagTypeWinner ? 'success': 'primary'
                            } />
                            <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                    <Stack spacing={0.5}>
                                        <Typography variant="subtitle2" component="span">
                                            {tag.officeType} {tag.districtDescription}
                                        </Typography>
                                        <Chip label={tag.tagTypeDescription} 
                                        color={
                                            tag.tagTypeId === TagTypeWinner ? 'success': 'primary'
                                        } 
                                        size="small"
                                        sx={{ width: 'fit-content' }} 
                                        variant="outlined" />
                                    </Stack>
                            </TimelineContent>
                            </TimelineItem>
                        ))
                    }
                    </Timeline>
                </Grid>  
            </CardContent>                                               
          </Card>
        </Grid>
    );
  };

export default ElectionTimelines;